import { Component, Input, Output, EventEmitter } from '@angular/core';

import { GridColumn, GridBaseOptionFilter } from '../../grid-control.model';

@Component({
  selector: 'sd-grid-desktop-inline-filter',
  templateUrl: './grid-desktop-inline-filter.component.html',
  styleUrls: ['./grid-desktop-inline-filter.component.scss']
})
export class GridDesktopInlineFilterComponent {
  @Input() columns: GridColumn[] = [];
  @Input() externalFilter: any = {};
  @Input() filter: any = {};
  @Input() filterOption: GridBaseOptionFilter;
  @Input() inlineExternal: {
    [key: string]: boolean;
  } = {};
  @Input() inlineColumn: {
    [key: string]: boolean;
  } = {};
  @Output() sdChange = new EventEmitter();
  isDesktop: boolean;
  displayKey = 'SDCUSTOM';
  constructor() { }

  onUpdateFilter = () => {
    this.sdChange.emit();
  }
}
